// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".existing-waivers{width:100%;align-items:center;gap:16px;position:relative}.confirm-form{width:100%}.edit-btn,.no-edit{width:50%;font-size:1em;font-weight:700}@media(max-width:900px){.edit-btn,.no-edit{width:100%}}.edit-btn:active,.edit-btn:focus,.edit-btn:hover{background:hsla(0,0%,88.6%,.1568627451)}.no-edit{cursor:default;pointer-events:none;border:none}", ""]);
// Exports
module.exports = exports;
